/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  TextField,
  Container,
  Button,
  MenuItem,
  Stack
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import * as Yup from "yup";
import { Autocomplete } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import { trackPromise } from 'react-promise-tracker';
import services from '../Service';
import TokenDecoder from 'src/helpers/TokenDecoder';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AddEditTable = ({ dialogbox, setDialogbox, isActive, details, cropName }) => {
  const handleClose = () => {
    setDialogbox(false);
    fieldsClear();
  };

  const [isFarmerClear, setIsFarmerClear] = useState(false);
  const [farmer, setFarmer] = useState([]);
  const [product, setProduct] = useState([]);
  const [productVarietyList, setProductVarietyList] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [isCleared, setIsCleared] = useState(false);
  const [IsClear, setIsClear] = useState(false);
  const [formData, setFormData] = useState({
    farmerID: "0",
    cropCategoryID: "0",
    cropID: "0",
    productVarietyID: "0",
    quntity: 0
  });

  const productcatogerySearchSchema = Yup.object().shape({
    farmerID: isActive == false ? Yup.number().min(1, 'Please Select Collector').required('Collector Required') : Yup.number().notRequired(),
    cropCategoryID: isActive == true ? Yup.number().min(1, 'Please Select Crop Category').required('Crop Category Required') : Yup.number().notRequired(),
    cropID: isActive == true ? Yup.number().min(1, 'Please Select Crop').required('Crop Required') : Yup.number().notRequired(),
    productVarietyID: Yup.number().min(1, 'Please Select Crop Variety').required('Crop Variety Required'),
    quntity: Yup.number().min(0.01, 'Quntity should be more than 0').required('Quntity Required')
  });

  const formik = useFormik({
    initialValues: {
      farmerID: formData.farmerID,
      cropCategoryID: formData.cropCategoryID,
      cropID: formData.cropID,
      productVarietyID: formData.productVarietyID,
      quntity: formData.quntity
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    },
  });


  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, validateForm, values } = formik;

  async function SubmitForm(values) {
    let model = {
      operationEntityID: parseInt(details.operationEntityID),
      date: details.date,
      farmerID: isActive == true ? parseInt(details.farmerID) : parseInt(values.farmerID),
      cropID: isActive == true ? parseInt(values.cropID) : parseInt(details.cropID),
      productVarietyID: parseInt(values.productVarietyID),
      quntity: parseFloat(values.quntity),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    let response = await services.AddCollectorCropForcasting(model);
    if (response.statusCode == "Success") {
      setDialogbox(false)
      fieldsClear()
      toast.success(response.message);
    }
    else {
      toast.error(response.message);
    }
  }

  useEffect(() => {
    if (isActive == 1) {
      trackPromise(GetProductCategoties());
    }
  }, []);

  useEffect(() => {
    if (isActive == 0) {
      trackPromise(GetCollectorDetailsByFactoryIDRouteID());
      setIsClear(!IsClear);
    }
  }, [details.operationEntityID]);

  useEffect(() => {
    trackPromise(GetProductDetails());
    setIsFarmerClear(!isFarmerClear);
  }, [formik.values.cropCategoryID]);

  useEffect(() => {
    if (isActive == 1) {
      trackPromise(GetAllProductVarietyByProductID(formik.values.cropID));
    }
  }, [formik.values.cropID]);

  useEffect(() => {
    if (isActive == 0) {
      trackPromise(GetAllProductVarietyByProductID(details.cropID));
    }
  }, [details.cropID]);

  async function GetCollectorDetailsByFactoryIDRouteID() {
    var res = await services.GetCollectorDetailsByFactoryIDRouteID(details.operationEntityID)
    if (res != null) {
      setFarmer(res);
    }
  }

  async function GetProductCategoties() {
    var res = await services.GetProductCategoties()
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetProductDetails() {
    var res = await services.GetProductsByFactoryIDProductcatogeryID(details.operationEntityID, formik.values.cropCategoryID)
    if (res != null) {
      setProduct(res);
    }
  }

  async function GetAllProductVarietyByProductID(cropID) {
    var res = await services.GetAllProductVarietyByProductID(cropID);
    if (res != null) {
      setProductVarietyList(res);
    }
  }

    function handleSearch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data.farmerID;

            setValues({
                ...values,
                farmerID: valueV
            });
        }
    }

  function handleSearchCrop(data, e) {
    if (data === undefined || data === null) {
      setValues({
        ...values,
        cropID: 0
      });
      return;
    } else {
      var valueV = data["productID"];

      setValues({
        ...values,
        cropID: valueV
      });
    }
  }
  function fieldsClear() {
    setFormData((prevState) => ({
      ...prevState,
      farmerID: "0",
      cropCategoryID: "0",
      cropID: "0",
      productVarietyID: "0",
      quntity: 0
    }));
    setIsCleared(!isCleared)
    setIsClear(!IsClear)
  }

  const filterOptions = (options, { inputValue }) => {
    const trimmedInput = inputValue.trim().toLowerCase();

    const filteredOptions = options.filter(option =>
        (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
        (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
        (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
    ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

    const exactMatchOptions = [];
    const nonExactMatchOptions = [];
    filteredOptions.forEach(option => {
        if (
            option.givenName.toLowerCase() === trimmedInput ||
            option.nic.toLowerCase() === trimmedInput ||
            option.farmerCode.toLowerCase() === trimmedInput
        ) {
            exactMatchOptions.push(option);
        } else {
            nonExactMatchOptions.push(option);
        }
    });

    return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
};

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={dialogbox}
        onBackdropClick="false"
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          <Typography
            color="textSecondary"
            gutterBottom
            variant="h3"
          >
            <Box textAlign="left" >
              Add Collector Crop
            </Box>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Container>
              <FormikProvider value={formik}>
                <ToastContainer
                  position="bottom-right"
                  pauseOnHover
                />
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <Stack spacing={2}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '5px' }} spacing={2}>
                      {isActive == false ?
                        <>
                          <Grid item md={4} xs={12} >
                            <Autocomplete fullWidth
                              key={IsClear}
                              id="farmerID"
                              options={farmer}
                              filterOptions={filterOptions}
                              getOptionLabel={(option) => option.givenName != null ? option.givenName.toString() : null}
                              onChange={(e, value) => handleSearch(value, e)}
                              defaultValue={null}
                              renderOption={(props, option) => (
                                <li {...props}>
                                    {`${option.givenName} - ${option.nic}`}
                                </li>
                            )}
                              renderInput={(params) =>
                                <TextField {...params}
                                  variant="outlined"
                                  name="farmerID"
                                  label="Collector Preferred Name / NIC *"
                                  size="small"
                                  fullWidth
                                  value={formik.values.farmerID}
                                  getOptionDisabled={true}
                                  helperText={touched.farmerID && errors.farmerID}
                                  error={Boolean(touched.farmerID && errors.farmerID)}
                                />
                              }
                            />
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <TextField
                              fullWidth
                              size="small"
                              label="Crop *"
                              value={cropName}
                              disabled={true}
                            />
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <TextField
                              select
                              fullWidth
                              size="small"
                              label="Crop Variety *"
                              value={formik.values.productVarietyID}
                              onChange={formik.handleChange}
                              {...getFieldProps('productVarietyID')}
                              error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                              helperText={touched.productVarietyID && errors.productVarietyID}
                            >
                              <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                              {productVarietyList.map((option) => (
                                option.isActive == true ? <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                                  {option.varietyName}
                                </MenuItem> : null
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <TextField
                              fullWidth
                              size="small"
                              label="Quntity *"
                              value={formik.values.quntity}
                              onChange={formik.handleChange}
                              {...getFieldProps('quntity')}
                              error={Boolean(touched.quntity && errors.quntity)}
                              helperText={touched.quntity && errors.quntity}
                              InputProps={{
                                inputProps: {
                                  step: 0.01,
                                  type: 'number',
                                  style: {
                                    textAlign: 'right',
                                  },
                                },
                              }}
                              onKeyDown={(evt) =>
                                (evt.key === "-") && evt.preventDefault()
                              }
                              onWheel={event => event.target.blur()}
                            />
                          </Grid>
                        </>
                        : null}
                      {isActive == true ?
                        <Grid item md={4} xs={12} >
                          <TextField
                            select
                            fullWidth
                            size="small"
                            label="Crop Category *"
                            value={formik.values.cropCategoryID}
                            onChange={formik.handleChange}
                            {...getFieldProps('cropCategoryID')}
                            error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}
                            helperText={touched.cropCategoryID && errors.cropCategoryID}
                          >
                            <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                            {productcatogery.map((option) => (
                              option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                {option.productCategoryName}
                              </MenuItem> : null
                            ))}
                          </TextField>
                        </Grid>
                        : null}
                      {isActive == true ?
                        <>
                          <Grid item md={4} xs={12} >
                            <Autocomplete fullWidth
                              key={isFarmerClear}
                              id="cropID"
                              options={product}
                              getOptionLabel={(option) => option.productName != null ? option.productName.toString() : null}
                              onChange={(e, value) => handleSearchCrop(value, e)}
                              defaultValue={null}
                              renderInput={(params) =>
                                <TextField {...params}
                                  variant="outlined"
                                  name="cropID"
                                  label="Crop *"
                                  size="small"
                                  fullWidth
                                  value={formik.values.cropID}
                                  getOptionDisabled={true}
                                  helperText={touched.cropID && errors.cropID}
                                  error={Boolean(touched.cropID && errors.cropID)}
                                />
                              }
                            />
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <TextField
                              select
                              fullWidth
                              size="small"
                              label="Crop Variety *"
                              value={formik.values.productVarietyID}
                              onChange={formik.handleChange}
                              {...getFieldProps('productVarietyID')}
                              error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                              helperText={touched.productVarietyID && errors.productVarietyID}
                            >
                              <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                              {productVarietyList.map((option) => (
                                option.isActive == true ? <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                                  {option.varietyName}
                                </MenuItem> : null
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <TextField
                              fullWidth
                              size="small"
                              label="Quntity *"
                              value={formik.values.quntity}
                              onChange={formik.handleChange}
                              {...getFieldProps('quntity')}
                              error={Boolean(touched.quntity && errors.quntity)}
                              helperText={touched.quntity && errors.quntity}
                              InputProps={{
                                inputProps: {
                                  step: 0.01,
                                  type: 'number',
                                  style: {
                                    textAlign: 'right',
                                  },
                                },
                              }}
                              onKeyDown={(evt) =>
                                (evt.key === "-") && evt.preventDefault()
                              }
                              onWheel={event => event.target.blur()}
                            />
                          </Grid>
                        </>
                        : null}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <Button
                        type="button"
                        variant="outlined"
                        color='error'
                        onClick={() => handleClose()}
                      > Close</Button>
                      <Button
                        type="submit"
                        color='secondary'
                        variant="contained"
                      >Add</Button>
                    </Stack>
                  </Stack>
                </Form>
              </FormikProvider>
            </Container>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
